var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-card",
        { staticClass: "mb5" },
        [
          _c(
            "el-form",
            {
              attrs: { inline: false, "label-position": "top", size: "small" },
            },
            [
              _c(
                "el-row",
                {
                  staticStyle: { "flex-wrap": "wrap" },
                  attrs: { gutter: 20, justify: "left", type: "flex" },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("customerManagements.daysStop"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("GlobalSetObj.all"),
                                clearable: "",
                                filterable: "",
                                multiple: "",
                              },
                              model: {
                                value: _vm.queryForm.params.daysDelayed,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "daysDelayed",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.daysDelayed",
                              },
                            },
                            _vm._l(_vm.dayList, function (item) {
                              return _c("el-option", {
                                key: item,
                                attrs: { label: item, value: item },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("newOrder.waybillStatus") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("GlobalSetObj.all"),
                                clearable: "",
                                filterable: "",
                                multiple: "",
                              },
                              model: {
                                value: _vm.queryForm.params.waybillStatusList,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "waybillStatusList",
                                    $$v
                                  )
                                },
                                expression:
                                  "queryForm.params.waybillStatusList",
                              },
                            },
                            _vm._l(
                              _vm.waybillStatusPageList,
                              function (item, ind) {
                                return _c("el-option", {
                                  key: ind,
                                  attrs: {
                                    label: item.label,
                                    value: item.code,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "customerManagements.trackingStalledRegion"
                            ),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              on: { change: _vm.regionChange },
                              model: {
                                value: _vm.queryForm.params.regionId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "regionId",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.regionId",
                              },
                            },
                            _vm._l(_vm.regionList, function (item, ind) {
                              return _c("el-option", {
                                key: ind,
                                attrs: {
                                  label:
                                    item.zhName + "（" + item.puName + "）",
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "customerManagements.trackingStalledState"
                            ),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                                multiple: "",
                              },
                              on: { change: _vm.stateChange },
                              model: {
                                value:
                                  _vm.queryForm.params.latestTraceStateList,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "latestTraceStateList",
                                    $$v
                                  )
                                },
                                expression:
                                  "queryForm.params.latestTraceStateList",
                              },
                            },
                            _vm._l(_vm.allTraceStateList, function (item, ind) {
                              return _c("el-option", {
                                key: ind,
                                attrs: {
                                  label: item.nameEn,
                                  value: item.twoCode,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("div", { staticClass: "flx-between" }, [
                      _c(
                        "div",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-search",
                                size: "small",
                                type: "primary",
                              },
                              on: { click: _vm.enterSearch },
                            },
                            [_vm._v(_vm._s(_vm.$t("newOrder.search")) + " ")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.advancedSearch },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("home.advancedSearch")) + " "
                              ),
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-refresh-left",
                                size: "small",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.resetForm()
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("newOrder.reset")) + " ")]
                          ),
                          _c(
                            "el-button",
                            {
                              staticStyle: { "margin-bottom": "10px" },
                              attrs: {
                                icon: "el-icon-upload2",
                                size: "small",
                                type: "primary",
                              },
                              on: { click: _vm.allExportOrder },
                            },
                            [_vm._v(_vm._s(_vm.$t("newOrder.export")) + " ")]
                          ),
                          _c(
                            "el-radio-group",
                            {
                              staticStyle: { "margin-left": "10px" },
                              attrs: { size: "small" },
                              on: { change: _vm.enterSearch },
                              model: {
                                value: _vm.queryForm.params.isTest,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm.params, "isTest", $$v)
                                },
                                expression: "queryForm.params.isTest",
                              },
                            },
                            [
                              _c("el-radio-button", { attrs: { label: 1 } }, [
                                _vm._v(_vm._s(_vm.$t("newOrder.Formal"))),
                              ]),
                              _c("el-radio-button", { attrs: { label: 2 } }, [
                                _vm._v(_vm._s(_vm.$t("newOrder.test1"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.queryForm.params.dataTypeBool,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "dataTypeBool",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.dataTypeBool",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("customerManagements.allData")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm.getSelectedConditions().length
            ? _c(
                "div",
                { staticClass: "selected-conditions" },
                [
                  _c("span", { staticClass: "selected-label" }, [
                    _c("i", { staticClass: "el-icon-filter" }),
                    _vm._v(
                      " " + _vm._s(_vm.$t("seller.selectedConditions")) + ": "
                    ),
                  ]),
                  _vm._l(_vm.getSelectedConditions(), function (item) {
                    return _c(
                      "el-tag",
                      {
                        key: item.key,
                        staticClass: "selected-tag",
                        attrs: { closable: "", size: "medium" },
                        on: {
                          close: function ($event) {
                            return _vm.removeCondition(item.key)
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(item.label) +
                            ": " +
                            _vm._s(item.value) +
                            " "
                        ),
                      ]
                    )
                  }),
                  _c(
                    "el-button",
                    {
                      staticClass: "clear-all-btn",
                      attrs: { type: "text" },
                      on: { click: _vm.clearAllConditions },
                    },
                    [
                      _c("i", { staticClass: "el-icon-delete" }),
                      _vm._v(" " + _vm._s(_vm.$t("seller.clearAll")) + " "),
                    ]
                  ),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "header-cell-style": { background: "#f2f2f2", color: "black" },
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label:
                    _vm.$t("GlobalSetObj.serial", "zh") +
                    "（" +
                    _vm.$t("GlobalSetObj.serial", "pu") +
                    "）",
                  align: "center",
                  type: "index",
                  width: "80",
                },
              }),
              _vm._l(_vm.tableHeaderList, function (item) {
                return _c("el-table-column", {
                  key: item.id,
                  attrs: {
                    label: item.label,
                    "min-width": item.cloWidth,
                    prop: item.prop,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            item.prop === "waybillNumber"
                              ? _c("div", [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        color: "#00A551",
                                        cursor: "pointer",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toOrderDetail(scope.row)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(scope.row.waybillNumber) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ])
                              : _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row[item.prop]
                                        ? "" + scope.row[item.prop]
                                        : "--"
                                    )
                                  ),
                                ]),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
            ],
            2
          ),
          _c("el-pagination", {
            staticStyle: { margin: "10px 0", float: "right" },
            attrs: {
              "current-page": _vm.queryForm.pageNumber,
              "page-size": _vm.queryForm.pageSize,
              "page-sizes": [10, 20, 50, 100],
              total: _vm.queryForm.total,
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            "append-to-body": true,
            visible: _vm.waybillDescription,
            "custom-class": "drawerClass",
            direction: "ltr",
            size: "90%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.waybillDescription = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { height: "calc(100vh - 67px)", overflow: "auto" } },
            [
              _c("detailPage", {
                key: _vm.detailKey,
                attrs: {
                  "query-track-param": _vm.queryTrackParam,
                  "query-type": "1",
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c("search-com", {
        ref: "searchComRef",
        attrs: {
          "site-list": _vm.siteList,
          "transfer-list": _vm.TransferList,
          "cargo-type-list": _vm.CARGO_TYPE,
          "default-time-value": _vm.timeValue,
        },
        on: { search: _vm.advancedSearchEvent },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }